@import '../../style/index';

:host {
  display: block;
  align-self: center;

  .button {
    position: relative;
    display: flex;
    gap: var(--spacings-xs);
    height: rem-calc(26px);
    background: transparent;
    justify-content: center;
    align-items: center;
    color: var(--colors-dark-base);
    font-family: $font-family-semibold;
    font-size: rem-calc(16px);
    line-height: 1;
    cursor: pointer;
    user-select: none;
    border: 0;
    text-decoration: none;

    @include xlarge-up {
      margin-top: 0;
    }

    &__icon {
      background: var(--colors-primary-base);
      border-radius: 50%;
      height: rem-calc(26px);
      width: rem-calc(26px);
      display: flex;

      img {
        margin: auto;
        height: rem-calc(16px);
        width: rem-calc(16px);
      }
    }

    &__text {
      font-size: rem-calc(12px);
    }
  }
}
